<template>
  <div class="div">
    <div class="center">
      <h1>微信扫码登录</h1>
      <img :src="'data:image/png;base64,'+qrImg" />
    </div>
    <footer id="footer">
      <div style="padding: 10px 144px;">
        备案号：
        <a href="http://www.beian.miit.gov.cn/" target="_blank">豫ICP备19037402号</a>
      </div>
    </footer>
  </div>
</template>
 
<script>
export default {
  name: "login",
  created() {
    this.uuid = this.getCode();
    this.login();
    this.intervalId = setInterval(() => {
      this.check();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.intervalId);
  },
  data() {
    return {
      httpRoot: this.$defines.hostRoot,
      uuid: "",
      intervalId: 0,
      qrImg: ""
    };
  },
  methods: {
    login() {
      const url = "/api/1.0/get/wxLoginQR?uuid=" + this.uuid;
      this.$http.login(url, { scanId: this.wxid }).then(res => {
        this.qrImg = res.data;
      });
    },
    check() {
      const url = "/api/1.0/check/" + this.uuid;
      this.$http.post(url, { scanId: this.wxid }).then(res => {
        console.log(res);
        if (res.code === 200 && res.data != null) {
          clearInterval(this.intervalId);
          this.$store.commit("setAccount", res.data);
          this.$store.commit("setRole", res.data.role.name);
          this.$router.push({
            path: "/product"
          });
        }
      });
    },
    getCode() {
      return Math.random()
        .toString(36)
        .substr(2);
    }
  }
};
</script>
<style lang="less" scoped>
.center img {
  width: 200px;
  height: 200px;
}
.center {
  position: fixed;
  top: 20%;
  left: 50%;
  vertical-align: -webkit-baseline-middle;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.div {
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  background: dark;
}
body {
  margin: 0;
  padding: 0;
}
</style>